import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOneCategory } from "../../redux/actions/categoryAction";
import { useLocation } from "react-router-dom";
import { subCategoryByCatId } from "../../redux/actions/subCategoryAction";

const SubCategoryHook = (id) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [loadingSpinner, setLoadingSpinner] = useState(true);
    
    useEffect(() => {
        const fetchData = async () => {
            setLoadingSpinner(true);
            await dispatch(getOneCategory(id));
            await dispatch(subCategoryByCatId(id, true));
            setLoadingSpinner(false);
            window.scrollTo(0, 0);
        };
        fetchData();
    }, [dispatch, location.pathname, id]);

    const category = useSelector((state) => state.subCategory.subCategoryByCat);
    const parentCategory = useSelector((state) => state.allCategory.oneCategory);
    const loading = useSelector((state) => state.allCategory.loading);

    const colors = [
        "var(--secondary-color)",
        "#F4DBA5",
        "#55CFDF",
        "#FF6262",
        "#0034FF",
        "var(--secondary-color)",
    ];

    return [category, loading, loadingSpinner, colors, parentCategory];
};

export default SubCategoryHook;
